/**
 * <TutorAvailabilitySkeleton> — la forme de « Ma dispo » pendant son premier chargement.
 *
 * La vraie surface du bandeau d'une phrase, puis l'éditeur de la semaine en squelette
 * (`<TutorWeekEditorSkeleton>`, le même que l'étape des créneaux de « Compléter mon profil »).
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { TutorWeekEditorSkeleton } from "../../organisms/TutorWeekEditor"

export function TutorAvailabilitySkeleton() {
    return (
        <Stack gap="6">
            <Skeleton shape="block" height={56} radius="lg" />
            <TutorWeekEditorSkeleton />
        </Stack>
    )
}
